class StepProcessorError extends Error {}

export default StepProcessorError;
